import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dbbbfae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid container-lg bg-light mt-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "col-12 col-lg-8 text-center" }, [
    /*#__PURE__*/_createTextVNode(" Learn "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://ology.substack.com/p/the-time-has-come",
      target: "_blank"
    }, "more"),
    /*#__PURE__*/_createTextVNode(" and "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://ology.substack.com/about",
      target: "_blank"
    }, "subscribe"),
    /*#__PURE__*/_createTextVNode(" for updates. ")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 0,
  class: "row"
}
const _hoisted_6 = { class: "col-12 d-flex align-items-center justify-content-center" }

import { ref, onMounted, Ref } from "vue";
    import {
        MDBContainer,
        MDBCard,
        MDBSpinner,
        MDBCardBody,
        MDBCardTitle,
        MDBCardText,
        MDBBtn,
    } from "mdb-vue-ui-kit";
    import { useRoute } from 'vue-router';
    import axios from "axios";
    import { Article } from "@/types/Article";

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const route = useRoute();
    const spinnerVisible = ref(false);
    const gettingArticle = ref(false);
    const articleData: Ref<Article | null> = ref(null);
    let article = ref(route.params.infoHash ? route.params.infoHash : null);
    let infoHash = article.value || '';

    /**
    * Get Article based on the provided infoHash
    *
    * @param infoHash
    */
    async function getData(infoHash: string) {
        spinnerVisible.value = true;
        gettingArticle.value = true;

        let response;
        let link = process.env.VUE_APP_API_ENDPOINT + '/api/article/' + infoHash;

        try {
            response = await axios.get(link);
        } catch (e) {
            articleData.value = null;
            console.log(e);
            gettingArticle.value = false;
            spinnerVisible.value = false;
        }

        let results = response?.data?.data;

        articleData.value = typeof(results) === 'undefined' ? null : results;

        spinnerVisible.value = false;
        gettingArticle.value = false;
    }

    onMounted(async () => {
        await getData(infoHash as string);
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(MDBBtn), {
      color: "primary",
      floating: "",
      size: "lg",
      class: _normalizeClass(spinnerVisible.value ? 'loader-div loading' : 'loader-div')
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MDBSpinner))
      ]),
      _: 1
    }, 8, ["class"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createVNode(_unref(MDBContainer), null, {
        default: _withCtx(() => [
          (articleData.value !== null)
            ? (_openBlock(), _createBlock(_unref(MDBCard), {
                key: 0,
                class: "mt-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(MDBCardBody), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MDBCardTitle), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(articleData.value.metainfo.info.publicSquare.package.title), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(MDBCardText), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(articleData.value.metainfo.info.publicSquare.package.description), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("a", {
                        href: (articleData.value.metainfo.info.publicSquare.package.canonicalUrl || ''),
                        target: "_blank",
                        class: "btn btn-primary"
                      }, "View Original", 8, _hoisted_4)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (articleData.value === null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", null, _toDisplayString(gettingArticle.value ? 'Finding article...' : 'Article Not Found'), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})